<template>
    <product-map 
    :data="data" 
    :show_goods="false"
    text="添加图片"
    ></product-map>
</template>
<script>
import ProductMap from '../../../../homePage/pluginscomponents/ProductMap'
export default {
  name: 'posterStyle',
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    ProductMap
  }
}
</script>
<style lang="scss">
.section-body .el-form-item__content{
  margin-left:100px;
}
</style>



// WEBPACK FOOTER //
// style.vue?35600c82